export const getRowIndex = (
  gridDimensions: number[],
  viewportIndex: number
) => {
  const [cols, _rows] = gridDimensions;
  return Math.floor(viewportIndex / cols);
};
